module.exports = __webpack_public_path__ + "img/home_list_icon5.ffbedfd0.png";